﻿<template>
  <PmwParagraph class="lang-text">
    <img :src="flagImgPath" :alt="text" class="lang-text--flag" />
    {{ text }}
  </PmwParagraph>
</template>

<script>
import PmwParagraph from '@solucoes/components-lib-tmp/src/components/elements/PmwParagraph'

export default {
  name: 'LanRateName',

  components: {
    PmwParagraph
  },

  props: {
    lang: {
      type: String,
      default: 'pt-BR'
    },

    text: String
  },

  computed: {
    flagImgPath() {
      return `/flags/${this.lang.toLowerCase().replace('-', '')}-flag.png`
    }
  }
}
</script>

<style lang="scss" scoped>
.lang-text {
  &--flag {
    display: inline-block;
    vertical-align: middle;
  }
}
</style>
